import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

export interface TokenInfo {
  token: string;
  refreshToken: string;
}

interface TokenStore {
  tokenInfo: TokenInfo | null;
  setTokenInfo: (tokenInfo: TokenInfo | null) => void;
}

export const useTokenStore = create<TokenStore>()(
  persist(
    (set) => ({
      tokenInfo: null,
      setTokenInfo: (tokenInfo) => set({ tokenInfo })
    }),
    {
      name: "user-tokens",
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        tokenInfo: state.tokenInfo
      })
    }
  )
);
